"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.entryDef = exports.stateDef = exports.learnerDef = void 0;
const joi_1 = __importDefault(require("joi"));
const general_1 = require("../general");
const schemaValidator_1 = require("../../util/schemaValidator");
const BusinessUnit_1 = require("../shared/BusinessUnit");
exports.learnerDef = {
    name: joi_1.default.string().required(),
    number: joi_1.default.number().required(),
};
exports.stateDef = {
    submitted: joi_1.default.boolean().default(false),
};
exports.entryDef = {
    ...general_1.daoObjSchemaDef,
    businessUnit: (0, schemaValidator_1.objectSchema)(BusinessUnit_1.businessUnitSchemaDef).required(),
    seriesId: joi_1.default.string().required(),
    centreId: joi_1.default.string().required(),
    qualificationId: joi_1.default.string().required(),
    assessmentCode: joi_1.default.string().required(),
    componentNumber: joi_1.default.string().required(),
    learner: (0, schemaValidator_1.objectSchema)(exports.learnerDef),
    state: (0, schemaValidator_1.objectSchema)(exports.stateDef),
    mark: joi_1.default.number().optional(),
};
